import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useHistory, Link } from 'react-router-dom';

function ViewMembers(props) {
	let history = useHistory();
	const { state } = props.location
	const [cgData] = useState(state[0]);
	const [kdData] = useState(state[1]);
	const [members, setMembers] = useState('');
	useEffect(() => {
		showMembers();
	}, []);
	console.log(localStorage.getItem("user_type"));
	const items = [];
	const showMembers = async () => {
		var userData = cgData;
		var i =1;
		var j =1;
		Object.keys(userData).forEach(function(key) {
			console.log(key);
			var title = <span className="designation"></span>;
			if(userData[key].user_type === 3){
				var title = <img src={require("./../images/crown.png").default} alt="" />;
			} else if(userData[key].user_type === 2){
				var title = <span className="designation">Relationship<br></br>Manager</span>;
			} else if(userData[key].user_type === 1){
				var title = <span className="designation">Account<br></br>Manager</span>;
			}
			var dp = require("./../images/defaultProfile.png").default;
			if(userData[key].dist_profile_pic !== ''){
				dp = userData[key].dist_profile_pic;
			}
			var temp = '';
			if (localStorage.getItem("user_type") === "distributor"){
				temp = <a className="item">
					<span className="member-number">{j}</span>
					<img src={dp} alt="imag" className="image" />
					<div className="in" >
						<div className="member">
							{userData[key].dist_name}
							<footer className="member-state">{userData[key].shop_name}</footer>
						</div>
						{title}
					</div>
				</a>;
			} else {
				temp = <Link  to={{ pathname:"/stats", state: [{"dau_percentage":0,"ppr_percentage":0,"tpr_percentage":0,"ul_percentage":0}, key] }} className="item" >
					<span className="member-number">{j}</span>
					<img src={dp} alt="imag" className="image" />
					<div className="in" >
						<div className="member">
							{userData[key].dist_name}
							<footer className="member-state">{userData[key].shop_name}</footer>
						</div>
						{title}
					</div>
				</Link>;
			}
			if(userData[key].user_type <= 3){
				items.push(
					<li key={i}>
						{temp}
					</li>
				);
				j++;
			}
			i++;
		});
		setMembers(items);
	}
  	return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/view-members.css'}]
	}/>
	<div className="row no-gutters">
      	<div className="application bg-grey">
        	<div  style=
				{{
					backgroundImage: `url('images/kd_bg.png'), linear-gradient(
				144deg, #997A5C, #6D6264, rgba(0, 0, 0, 0.25))`,
					backgroundBlendMode: `multiply`,
					backgroundSize: `100% 100%`,
					backgroundPosition: `left`,
					borderBottomLeftRadius: `8px`,
					borderBottomRightRadius: `8px`,
					height: `84px`,
					backgroundRepeat: `no-repeat`
				}}>
            	<div className="appHeader bg-transparent text-light position-relative">
					<div className="left">
						<a className="headerButton goBack"  onClick={() => history.goBack()} >
							<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
						</a>
					</div>
            		<div className="pageTitle">Kingdom {kdData.kd_name}</div>
					<div className="right">
						<Link to="/faq" className="headerButton">
							<img src={require("./../images/faq.png").default} alt="faq" className="img-fluid" />
						</Link>
					</div>
            	</div>
        	</div>

			<div className="section">
				<div className="memebers">
					<p>Memebers of your kingdom</p>
				</div>
			</div>
			<div className="section bg-grey members-section px-14" id="bg-grey">
				<ul className="listview image-listview memberlist">
					{members}
				</ul>
				
			</div>
        </div>
		<div className="bg"></div>
    </div>
</>
  	);
}

export default ViewMembers;
